import '.a{display:flex;}.ssr-plugin'
import '.ad{align-items:stretch;}.ssr-plugin'
import '.n{justify-content:center;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.cn{background:var(--shades-white);}.ssr-plugin'
import '.bt{flex-grow:1;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.bc{max-width:77.5rem;}.ssr-plugin'
import '.db{justify-content:stretch;}.ssr-plugin'
import '.dc{position:sticky;}.ssr-plugin'
import '.cd{top:0;}.ssr-plugin'
import '.dd{z-index:10;}.ssr-plugin'
import '.de{padding-block:1rem;}.ssr-plugin'
import '.df{height:3rem;}.ssr-plugin'
import '.a3{justify-content:space-between;}.ssr-plugin'
import '.dg{flex-wrap:wrap;}.ssr-plugin'
import '.dh{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.bh{margin-top:2rem;}.ssr-plugin'
import '.di{padding-bottom:6rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const PlotRegistryPageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="a ad n b cn"
      >
        <div className="bt a c n b"
        >
          <div className="bc a b db dc cd dd cn"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="de df a a3 c dg"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="dh a b ad bh di bc"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
